import { Monitor } from 'lucide-react'
import inciteLogo from '../assets/incite.png'

// Shown instead of the app on phone-sized screens — InCite is desktop-only for now.
export default function MobileGate() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white px-8 text-center">
      <img src={inciteLogo} alt="InCite" className="w-44 h-auto mb-8" onError={(e) => { e.currentTarget.style.display = 'none' }} />
      <div className="w-12 h-12 rounded-2xl bg-brand/10 text-brand flex items-center justify-center mb-4">
        <Monitor size={24} />
      </div>
      <h1 className="text-xl font-bold text-ink leading-snug">InCite OS is not available on mobile yet.</h1>
      <p className="text-sm text-ink-soft mt-3 max-w-xs">Please open InCite on a desktop or laptop for the full experience.</p>
    </div>
  )
}
